import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

/**
 * Type-safe, validated environment. Only VITE_-prefixed vars reach the browser.
 * Build fails fast if a required var is missing or malformed.
 */
export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_API_BASE_URL: z.string().min(1),
    VITE_WS_URL: z.string().min(1),
    VITE_APP_NAME: z.string().default('Edifice AI Automation'),
    VITE_APP_ENV: z.enum(['development', 'staging', 'production']).default('development'),
    VITE_CDN_URL: z.string().optional(),

    VITE_FIREBASE_API_KEY: z.string().min(1),
    VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
    VITE_FIREBASE_PROJECT_ID: z.string().min(1),
    VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1),
    VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
    VITE_FIREBASE_APP_ID: z.string().min(1),
    VITE_FIREBASE_VAPID_KEY: z.string().optional(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
